package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.Serializable

@Serializable
data class Page<T> (
    val list: List<T> = emptyList(),
    val currentPage: Int,
    val prevPage: Int? = null,
    val nextPage: Int? = null,
    val totalPages: Int = 1,
    val listedItems: Int = 0,
    val totalItems: Int = 0,
)

class PageOf<T>  {

    operator fun invoke(
        data: List<T>,
        limit: Int=10,
        requestPage: Int=1,
    ):Page<T> {

        val properLimit = if (limit <= 0) 10 else limit
        val totalPages : Int = (data.size + properLimit - 1) / properLimit
        val properRequestPage = if (requestPage <= 0) {
            1
        } else {
            if (requestPage > totalPages) totalPages else requestPage
        }

        val fromIndex = (properRequestPage - 1) * properLimit
        val endIndex = minOf(fromIndex + properLimit, data.size)
        val returnableData = if (fromIndex>-1) {
            data.subList(fromIndex, endIndex)
        } else {
            emptyList<T>()
        }
//        val returnableData = data.subList(fromIndex, endIndex)
        val prevPage = if (properRequestPage > 1) properRequestPage - 1 else null
        val nextPage = if (properRequestPage < totalPages) properRequestPage + 1 else null



        return Page(
            list = returnableData,
            currentPage = properRequestPage,
            prevPage = prevPage,
            nextPage = nextPage,
            totalPages = totalPages,
            listedItems = returnableData.size,
            totalItems = data.size
        )

    }



}





